export default __webpack_public_path__ + "static/media/placeholder.07458a85.jpg";